import { useState, useCallback, useEffect, memo, useRef } from "react";
import { useWindowEvent, delay, getWindowInnerWidth } from "../utils/utils";
import BoardView from "../components/board-view/board-view";
import BoardInfo from "./board-info/board-info";
import { getMoveCandidates } from "../board-logic/ai/move-finder";
import { Board } from "../board-logic/board/board";
import { defaultBoardState, scoreEvalPlugins } from "./board-default-state";
import MoveSound from "./assets/move.mp3";
import logo from "./assets/images/logo.png";
import chess from "./assets/images/chess.png";
import culo from "./assets/images/culo.png";

const BoardMemo = memo(BoardView);

const boardMaxWidth = 700;

const moveSound = new Audio(MoveSound);
moveSound.volume = 0.3;

const board = new Board({ x: 7, y: 7, hills: ["D4"] });
board.state.setStateFromJSON(defaultBoardState);

/**
 *
 */
export default function BoardPage() {
  const [screenSize, updateScreenSize] = useState<"sm" | "lg">("sm");
  const [boardWidth, updateBoardWidth] = useState(0);
  const [boardInfoSize, updateBoardInfoSize] = useState<{ w: number; h: number }>({ w: 0, h: 0 });
  const [gameMode] = useState("AGAINST_CPU");
  const [selectTile, setSelectTile] = useState<null | string>(null);
  const moveToPlayTimeoutId = useRef(0);
  const [playable, updatePlayable] = useState(true);
  // 'token' is a random arbitrary number.
  // It's used to force react to re-render board-view after board.move() or board.reset()
  // I initially tried to listern to board.state.turn changes inside board-view but
  // that didn't always trigger a re-render. Weird React bug :/
  const [token, setToken] = useState(Math.random());

  /**
   *
   */
  const adjustBoardSize = useCallback(() => {
    // 'window.innerWidth' is not reliable
    const windowInnerWidth = getWindowInnerWidth();
    // Don't go bigger than max width
    let newBoardWidth = Math.min(windowInnerWidth, boardMaxWidth);
    let screenSize: "sm" | "lg" = "sm";
    let boardInfoSize = { w: newBoardWidth, h: 140 };

    if (newBoardWidth > 660) {
      screenSize = "lg";
      newBoardWidth -= 160;
      boardInfoSize = { w: 120, h: newBoardWidth + 20 };
    }
    updateScreenSize(screenSize);
    updateBoardWidth(newBoardWidth);
    updateBoardInfoSize(boardInfoSize);
  }, []);

  // On initial render
  useEffect(adjustBoardSize, [adjustBoardSize]);
  // On Window resize
  useWindowEvent("resize", adjustBoardSize);

  /**
   *
   */
  const simulateComputerPlay = useCallback(async () => {
    // Disable board interaction if it's computer's turn
    updatePlayable(false);
    const seed = board.state.seed;

    await delay(500);

    const moveCandidate = getMoveCandidates(board, scoreEvalPlugins);
    if (moveCandidate === null) {
      return console.error("No move candidates found");
    }
    const [moveFrom, moveTo] = moveCandidate;

    setSelectTile(moveFrom);
    await delay(1500);

    // Make sure there's no turn mis-match.
    // e.g User pressing the 'Restart' button
    // while move animation is hapening
    if (board.state.seed !== seed) return;

    board.move(moveFrom, moveTo);
    setToken(Math.random());
    moveSound.play();
    setSelectTile(null);
    updatePlayable(true);
  }, []);

  /**
   * Called when player makes a new move
   */
  const onPieceMove = useCallback(
    (from: string, to: string) => {
      if (!board.isValidMove(from, to)) {
        console.error(`Invalid move: [${from}, ${to}]`);
        return;
      }
      board.move(from, to);
      setToken(Math.random());
      if (board.state.turn !== 1) moveSound.play();

      // Can't move or click pieces if game over
      if (board.state.status !== "ACTIVE") {
        return updatePlayable(false);
      }

      if (gameMode === "AGAINST_HUMAN") return;
      if (board.state.player === "WHITE") return;
      // If game not over and it's Black's turn
      // and game mode is Against CPU, play CPU's turn
      simulateComputerPlay();
    },
    [gameMode, simulateComputerPlay]
  );

  /**
   *
   */
  function onRestart() {
    if (board.state.turn === 1) return;
    board.state.reset();
    setToken(Math.random());
    setSelectTile(null);
    updatePlayable(true);
    // Clear move simulation timeout if it exists
    if (moveToPlayTimeoutId.current) {
      clearTimeout(moveToPlayTimeoutId.current);
    }
  }

  return (
    <div>
      <div className="koth-page-header">
        <div className="koth-logo"><img className="logo" src={logo} alt="Stronzemon Chess" title="Stronzemon Chess" /><img className="chess" src={chess} alt="Stronzemon Chess" title="Stronzemon Chess" /></div>
      </div>
      <div className="koth-page">
        <div
          className={`koth-board-wrapper ${screenSize}  ${
            board.state.player === "WHITE" ? "white-turn" : "black-turn"
          }`}
        >
          <div className="koth-board">
            <BoardMemo
              board={board}
              token={token}
              gameMode={gameMode}
              playable={playable}
              boardMaxWidth={boardWidth}
              selectTile={selectTile}
              onPieceMove={onPieceMove}
            />
          </div>
          <BoardInfo
            board={board}
            restart={onRestart}
            height={boardInfoSize.h}
            width={boardInfoSize.w}
            screenSize={screenSize}
          />
        </div>
      </div>
      <div className="koth-page-footer">
        <p className="right">Copyright © 2069 <a href="http://prophilax.it" target="_blank" rel="noreferrer">Prophilax</a></p>
        <p className="left">Fatto con il <img src={culo} alt="Culo" /> da <a href="https://alesancogames.com" target="_blank" rel="noreferrer">AlesancoGames</a></p>
      </div>
    </div>
  );
}
